export default "__VITE_ASSET__BbhmYcl7__"